export default __webpack_public_path__ + "static/25-b6d0aaa63af2575577cfb284df426946.jpg";